'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _loginContactFormValidation = require('./loginContactFormValidation');

var _loginContactFormValidation2 = _interopRequireDefault(_loginContactFormValidation);

var _auth = require('redux/modules/auth');

var _formComponents = require('components/formComponents');

var _auth2 = require('selectors/auth');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var LoginContactForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: (0, _auth2.getUser)(state)
  };
}, { contact: _auth.contact }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'contactForm',
  propNamespace: 'contactForm',
  validate: _loginContactFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(LoginContactForm, _Component);

  function LoginContactForm() {
    (0, _classCallCheck3.default)(this, LoginContactForm);
    return (0, _possibleConstructorReturn3.default)(this, (LoginContactForm.__proto__ || (0, _getPrototypeOf2.default)(LoginContactForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginContactForm, [{
    key: 'submit',
    value: function submit(formData) {
      var _props = this.props,
          onSend = _props.onSend,
          reset = _props.contactForm.reset;

      return this.props.contact(formData).promise.then(function (resp) {
        reset();
        onSend(resp.data);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$contactForm = _props2.contactForm,
          submitting = _props2$contactForm.submitting,
          invalid = _props2$contactForm.invalid,
          handleSubmit = _props2$contactForm.handleSubmit,
          user = _props2.user,
          t = _props2.t;

      var styles = require('./LoginContactForm.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.title },
          t('contactForm##title')
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal', onSubmit: handleSubmit(this.submit) },
          !user && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reduxForm.Field, { name: 'firstName', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('First name') }),
            _react2.default.createElement(_reduxForm.Field, { name: 'lastName', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Last name') }),
            _react2.default.createElement(_reduxForm.Field, { name: 'company', type: 'text', component: _formComponents.formSimpleTextInput, placeholder: t('Company') }),
            _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, placeholder: t('Email') })
          ),
          _react2.default.createElement(_reduxForm.Field, {
            name: 'enquiryMessage',
            type: 'textarea',
            component: _formComponents.formSimpleTextInput,
            placeholder: t('Question/Request'),
            bottomHint: t('Feel free to share any relevant information with us.')
          }),
          _react2.default.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary pull-right pos-rel', disabled: submitting || invalid },
            t('send'),
            submitting && _react2.default.createElement(_components.Loader, { mask: true })
          )
        )
      );
    }
  }]);
  return LoginContactForm;
}(_react.Component), _class3.propTypes = {
  contact: _propTypes2.default.func,
  contactForm: _propTypes2.default.object,
  onSend: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = LoginContactForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginContactForm/LoginContactForm.js
// module id = 2030
// module chunks = 1